/* eslint-disable */

export interface SponsorshipCryptoAuthorization {
  /** The customer's feature authorizations */
  feature_authorizations?: SponsorshipCryptoAuthorizationFeatureAuthorization[];
}

export enum SponsorshipCryptoAuthorizationFeature {
  BTC_EXCHANGE = "BTC_EXCHANGE",
}

export interface SponsorshipCryptoAuthorizationFeatureAuthorization {
  feature?: SponsorshipCryptoAuthorizationFeature;
  /** Whether the customer has been authorized for this feature */
  is_authorized?: boolean;
}
